import { InboundFlowRoutes, OutboundFlowRoutes } from '@/shared/types/router.types'

export const DEFAULT_FLOW_STEPS_COUNT = 2
export const DEFAULT_FLOW_CURRENT_STEP = 1
export const DEFAULT_FLOW_FIRST_STEP = 1

export const TRAVEL_FLOW_OUTBOUND: OutboundFlowRoutes[] = [
  OutboundFlowRoutes.DESTINATION,
  OutboundFlowRoutes.DATES,
  OutboundFlowRoutes.TRAVELERS,
  OutboundFlowRoutes.CONTACTS,
  OutboundFlowRoutes.SELECT_PLANS,
  OutboundFlowRoutes.PERSONAL_INFORMATION,
  OutboundFlowRoutes.INSURED_TRAVELERS,
  OutboundFlowRoutes.QUOTE,
]

export const TRAVEL_FLOW_INBOUND: InboundFlowRoutes[] = [
  InboundFlowRoutes.RESIDENCE,
  InboundFlowRoutes.DATES,
  InboundFlowRoutes.TRAVELERS,
  InboundFlowRoutes.CONTACTS,
  InboundFlowRoutes.SELECT_PLANS,
  InboundFlowRoutes.PERSONAL_INFORMATION,
  InboundFlowRoutes.INSURED_TRAVELERS,
  InboundFlowRoutes.QUOTE,
]

export const PLANS_WITH_ADDONS_ID = [
  5005, 5006, 5007, 5003, 5002, 5001, 5055, 5054, 5053, 5064, 5065, 5066, 5063,
]

export const INBOUND_MAX_AGE = 65
export const OUTBOUND_MAX_AGE = 70

export const GENDER_MALE = '1'
export const GENDER_FEMALE = '2'

export const DEFAULT_START_DATE = new Date(1991, 0, 1)
